import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isNull from "lodash/isNull";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React, { useEffect, useRef, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useUrlParams, useIsMounted, Input, Dropdown, RangePicker, SwitchButton, useUser } from 'components';
import { creditsStatusName, creditsStatusNameSelect, daysExpiredName, daysExpiredNameSelect, CREDITS_SEARCH_TYPE, creditSearchTypesName, creditSearchTypesNameSelect } from 'enums';
import { tableHeaderContainer, primaryRow, advancedRow, filterToggle, filterBadge, filterField, filterFieldWide, filterFieldAuto } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var loanDurationOptions = _toConsumableArray(Array(13)).map(function (e, i) {
  return {
    label: "".concat(i + 1 === 13 ? '12+' : i + 1, " \u043C."),
    value: i + 1
  };
});

var countUnpaidPaymentsOptions = _toConsumableArray(Array(4)).map(function (e, i) {
  return {
    label: "".concat(i + 1, " \u043C."),
    value: i + 1
  };
});

var sortOptions = [{
  label: 'Най-нови',
  value: 'id',
  direction: 'desc'
}, {
  label: 'Падежирали',
  value: 'due_date',
  direction: 'asc'
}];

var CreditsTableHeader = function CreditsTableHeader(_ref) {
  var getData = _ref.getData;

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var searchBy = urlQueryParams.searchBy,
      search = urlQueryParams.search,
      status = urlQueryParams.status,
      daysExpired = urlQueryParams.daysExpired,
      loanDuration = urlQueryParams.loanDuration,
      overUnder = urlQueryParams.overUnder,
      priceTag = urlQueryParams.priceTag,
      employee = urlQueryParams.employee,
      approvedBy = urlQueryParams.approvedBy,
      sortBy = urlQueryParams.sortBy,
      office = urlQueryParams.office,
      countUnpaidPayments = urlQueryParams.countUnpaidPayments,
      startDate = urlQueryParams.startDate,
      endDate = urlQueryParams.endDate,
      maturityStartDate = urlQueryParams.maturityStartDate,
      maturityEndDate = urlQueryParams.maturityEndDate;
  var queryParams = useRef(urlQueryParams);
  var isMounted = useIsMounted();
  var advancedFilterCount = useMemo(function () {
    var count = 0;
    if (loanDuration) count++;
    if (priceTag) count++;
    if (employee) count++;
    if (approvedBy) count++;
    if (office) count++;
    if (countUnpaidPayments) count++;
    if (startDate || endDate) count++;
    if (maturityStartDate || maturityEndDate) count++;
    return count;
  }, [loanDuration, priceTag, employee, approvedBy, office, countUnpaidPayments, startDate, endDate, maturityStartDate, maturityEndDate]);
  useEffect(function () {
    if (isMounted.current) {
      var _queryParams$current$, _queryParams$current, _queryParams$current$2, _queryParams$current2, _queryParams$current$3, _queryParams$current3, _queryParams$current4;

      queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
        searchBy: (_queryParams$current$ = (_queryParams$current = queryParams.current) === null || _queryParams$current === void 0 ? void 0 : _queryParams$current.searchBy) !== null && _queryParams$current$ !== void 0 ? _queryParams$current$ : CREDITS_SEARCH_TYPE.borrower_id_number,
        sortBy: (_queryParams$current$2 = (_queryParams$current2 = queryParams.current) === null || _queryParams$current2 === void 0 ? void 0 : _queryParams$current2.sortBy) !== null && _queryParams$current$2 !== void 0 ? _queryParams$current$2 : 'id',
        direction: (_queryParams$current$3 = (_queryParams$current3 = queryParams.current) === null || _queryParams$current3 === void 0 ? void 0 : _queryParams$current3.direction) !== null && _queryParams$current$3 !== void 0 ? _queryParams$current$3 : 'desc'
      }, !(queryParams !== null && queryParams !== void 0 && (_queryParams$current4 = queryParams.current) !== null && _queryParams$current4 !== void 0 && _queryParams$current4.overUnder) && {
        overUnder: false
      });
      getData(queryParams.current);
    }
  }, []);
  useEffect(function () {
    if (advancedFilterCount > 0) setExpanded(true);
  }, []);

  var handleSearchTypeChange = function handleSearchTypeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      searchBy: value
    });
  };

  var handleSearchChange = function handleSearchChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      search: value
    });
    _isNull(value) && getData(queryParams.current);
  };

  var handleStatusChange = function handleStatusChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      status: value
    });
    getData(queryParams.current);
  };

  var handleDaysExpiredChange = function handleDaysExpiredChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      daysExpired: value
    });
    getData(queryParams.current);
  };

  var handleLoanDurationChange = function handleLoanDurationChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      loanDuration: value
    });
    getData(queryParams.current);
  };

  var handleOverUnderChange = function handleOverUnderChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      overUnder: value
    });
    getData(queryParams.current);
  };

  var handlePriceTagChange = function handlePriceTagChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      priceTag: value
    });
  };

  var handleEmployeeChange = function handleEmployeeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      employee: value
    });
    getData(queryParams.current);
  };

  var handleApprovedByChange = function handleApprovedByChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      approvedBy: value
    });
    getData(queryParams.current);
  };

  var handleOfficeChange = function handleOfficeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      office: value
    });
    getData(queryParams.current);
  };

  var handleCountUnpaidPaymentsChange = function handleCountUnpaidPaymentsChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      countUnpaidPayments: value
    });
    getData(queryParams.current);
  };

  var handleDateChange = function handleDateChange(_ref2) {
    var startDate = _ref2.startDate,
        endDate = _ref2.endDate;
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      startDate: startDate,
      endDate: endDate
    });
    getData(queryParams.current);
  };

  var handleMaturityDateChange = function handleMaturityDateChange(_ref3) {
    var startDate = _ref3.startDate,
        endDate = _ref3.endDate;
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      maturityStartDate: startDate,
      maturityEndDate: endDate
    });
    getData(queryParams.current);
  };

  var handleSortChange = function handleSortChange(data) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      sortBy: data === null || data === void 0 ? void 0 : data.value
    }, (data === null || data === void 0 ? void 0 : data.direction) && {
      direction: data === null || data === void 0 ? void 0 : data.direction
    });
    getData(queryParams.current);
  };

  return ___EmotionJSX("section", {
    css: tableHeaderContainer
  }, ___EmotionJSX("div", {
    css: primaryRow
  }, ___EmotionJSX("div", {
    css: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    noClear: true,
    placeholder: "\u0422\u044A\u0440\u0441\u0435\u043D\u0435 \u043F\u043E",
    value: creditSearchTypesName[searchBy],
    options: creditSearchTypesNameSelect,
    onChange: handleSearchTypeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX("div", {
    css: filterFieldWide
  }, ___EmotionJSX(Input, {
    small: true,
    clear: true,
    placeholder: "\u2116, \u0418\u043C\u0435, \u0415\u0413\u041D, \u0410\u0434\u0440\u0435\u0441 \u0438 \u0422\u0435\u043B.",
    onChange: handleSearchChange,
    onKeyDown: function onKeyDown(e) {
      return e.keyCode === 13 && getData(queryParams.current);
    },
    value: search
  })), ___EmotionJSX("div", {
    css: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    placeholder: "\u0421\u0442\u0430\u0442\u0443\u0441",
    value: creditsStatusName[status],
    options: creditsStatusNameSelect,
    onChange: handleStatusChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX("div", {
    css: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    placeholder: "\u0414\u043D\u0438 \u043F\u0440\u043E\u0441\u0440\u043E\u0447\u0438\u0435",
    value: daysExpiredName[daysExpired],
    options: daysExpiredNameSelect,
    onChange: handleDaysExpiredChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX("div", {
    css: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    placeholder: "\u0421\u043E\u0440\u0442\u0438\u0440\u0430\u043D\u0435 \u043F\u043E",
    value: sortBy,
    options: sortOptions,
    onChange: handleSortChange
  })), ___EmotionJSX("div", {
    css: filterFieldAuto
  }, ___EmotionJSX("div", {
    role: "button",
    tabIndex: "0",
    css: filterToggle,
    onClick: function onClick() {
      return setExpanded(function (prev) {
        return !prev;
      });
    }
  }, ___EmotionJSX("i", {
    className: expanded ? 'las la-angle-up' : 'las la-sliders-h'
  }), ___EmotionJSX("span", null, expanded ? 'Скрий' : 'Филтри'), advancedFilterCount > 0 && ___EmotionJSX("span", {
    css: filterBadge
  }, advancedFilterCount)))), expanded && ___EmotionJSX("div", {
    css: advancedRow
  }, ___EmotionJSX("div", {
    css: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    placeholder: "\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E\u0441\u0442",
    value: loanDuration,
    options: loanDurationOptions,
    onChange: handleLoanDurationChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX("div", {
    css: filterFieldAuto,
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.6em',
      minHeight: '3.6rem'
    }
  }, ___EmotionJSX("p", null, "\u041F\u041E\u0414"), ___EmotionJSX(SwitchButton, {
    value: !!overUnder,
    onChange: handleOverUnderChange
  }), ___EmotionJSX("p", null, "\u041D\u0410\u0414")), ___EmotionJSX("div", {
    css: filterField
  }, ___EmotionJSX(Input, {
    small: true,
    placeholder: "\u0421\u0443\u043C\u0430 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
    onChange: handlePriceTagChange,
    onKeyDown: function onKeyDown(e) {
      return e.keyCode === 13 && getData(queryParams.current);
    },
    value: priceTag
  })), (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.employees) && ___EmotionJSX("div", {
    css: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u0421\u043B\u0443\u0436\u0438\u0442\u0435\u043B",
    displayKey: "name",
    uniqueKey: "id",
    value: employee,
    options: roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.employees,
    onChange: handleEmployeeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), ___EmotionJSX("div", {
    css: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u041E\u0434\u043E\u0431\u0440\u0438\u043B",
    displayKey: "name",
    uniqueKey: "id",
    value: approvedBy,
    options: roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.employees,
    onChange: handleApprovedByChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.offices) && ___EmotionJSX("div", {
    css: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u041E\u0444\u0438\u0441",
    displayKey: "name",
    uniqueKey: "id",
    value: office,
    options: roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.offices,
    onChange: handleOfficeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), ___EmotionJSX("div", {
    css: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    placeholder: "\u041E\u0441\u0442\u0430\u0432\u0430\u0449\u0438 \u0432\u043D\u043E\u0441\u043A\u0438",
    value: countUnpaidPayments,
    options: countUnpaidPaymentsOptions,
    onChange: handleCountUnpaidPaymentsChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX("div", {
    css: filterFieldAuto
  }, ___EmotionJSX(RangePicker, {
    label: "\u0414\u0430\u0442\u0430",
    startDatePlaceholderText: "\u041E\u0442 \u0434\u0430\u0442\u0430",
    endDatePlaceholderText: "\u0414\u043E \u0434\u0430\u0442\u0430",
    startDate: startDate,
    endDate: endDate,
    onChange: handleDateChange
  })), ___EmotionJSX("div", {
    css: filterFieldAuto
  }, ___EmotionJSX(RangePicker, {
    noFuture: false,
    label: "\u041F\u0430\u0434\u0435\u0436",
    startDatePlaceholderText: "\u041E\u0442 \u0434\u0430\u0442\u0430",
    endDatePlaceholderText: "\u0414\u043E \u0434\u0430\u0442\u0430",
    startDate: maturityStartDate,
    endDate: maturityEndDate,
    onChange: handleMaturityDateChange
  }))));
};

CreditsTableHeader.propTypes = {
  getData: PropTypes.func
};
export default CreditsTableHeader;